import React from "react";
import { CreateAccountForm } from "../../components/CreateAccount/CreateAccountForm";

const CreateAccountPage = (): React.ReactElement => <CreateAccountForm />;

export default CreateAccountPage;
